<footer class="footer py-3 bg-light">
    <div class="container">
      <span class=" text-white">© 2020 Copyright LIS . All Rights Reserved</span>
    </div>
  </footer>